module.exports = __webpack_public_path__ + "static/lova-sm-detail-1275c11153f36ffc8eedf69e6dce357c.jpg";